import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "billing-section mt-2" }
const _hoisted_2 = { class: "billing-card" }
const _hoisted_3 = { class: "billing-icon" }
const _hoisted_4 = { class: "billing-copy" }
const _hoisted_5 = { class: "billing-label" }
const _hoisted_6 = { class: "billing-value" }

import { computed } from "vue";
import { formatDate } from "@/shared/utils/utils";

type SubscriptionDetailResponse = {
  recurring_subscription?: {
    billing_interval: string | null;
    start_date: string | null;
    next_billing_date: string | null;
    end_date: string | null;
  };
};


export default /*@__PURE__*/_defineComponent({
  __name: 'SubscriptionDetailBillingCard',
  props: {
    detail: {}
  },
  setup(__props: any) {

const props = __props;

function titleCase(value: string | null | undefined) {
  const text = String(value ?? "").trim();
  if (!text) return "-";
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

const billingRows = computed(() => [
  {
    label: "Billing cycle",
    value: props.detail.recurring_subscription?.billing_interval
      ? `Every 1 ${titleCase(props.detail.recurring_subscription.billing_interval)}`
      : "-",
    icon: "mdi-refresh",
  },
  {
    label: "Start date",
    value: props.detail.recurring_subscription?.start_date
      ? formatDate(props.detail.recurring_subscription.start_date)
      : "-",
    icon: "mdi-calendar-start-outline",
  },
  {
    label: "Next billing",
    value: props.detail.recurring_subscription?.next_billing_date
      ? formatDate(props.detail.recurring_subscription.next_billing_date)
      : "-",
    icon: "mdi-calendar-clock-outline",
  },
  {
    label: "End date",
    value: props.detail.recurring_subscription?.end_date
      ? formatDate(props.detail.recurring_subscription.end_date)
      : "Ongoing",
    icon: "mdi-calendar-end-outline",
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "px-2" }, [
      _createElementVNode("p", { class: "billing-section-title" }, "Billing")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(billingRows.value, (row) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "billing-row",
          key: row.label
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, {
              size: "18",
              color: "deep-orange-darken-1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.icon), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(row.label), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(row.value), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})